/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA;
 */

import request, { getEndpointUrl } from '@/core/api/apiRequest';

/**
 * Returns ACS events for a specific assessment/session identifier.
 * For the current backend contract, the gateway route is `/api/v1/acs/{assessmentId}/log`
 * and forwards the value as a `deliveryExecutionId` filter.
 * @param {string} assessmentId
 * @param {Object} options
 * @param {number} [options.pageSize]
 * @param {number} [options.pageNum]
 * @param {string} [options.sortOrder]
 * @returns {Promise<Response>}
 */
export const getAcsEvents = async (assessmentId, options = {}) => {
    const url = getEndpointUrl(
        { domain: 'LTI_BACKEND_SERVICE', endpoint: 'acsEvents' },
        { id: encodeURIComponent(assessmentId) },
        options
    );

    return request(url, { method: 'GET' });
};
